
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry/food-beverage/whatsapp",
      function () {
        return require("private-next-pages/industry/food-beverage/whatsapp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry/food-beverage/whatsapp"])
      });
    }
  